
(function() {
  var result = { translations: { "fi": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} vrk", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} vrk", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, alanro {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fi": "static-7.1019"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1019",
    "ar-eg": "static-7.1019",
    "bg": "static-7.1019",
    "bn": "static-7.1019",
    "ca-es": "static-7.1019",
    "cs": "static-7.1019",
    "da": "static-7.1019",
    "de": "static-7.1019",
    "el": "static-7.1019",
    "en-gb": "static-7.1019",
    "en": "static-7.1019",
    "es-mx": "static-7.1019",
    "es": "static-7.1019",
    "fi": "static-7.1019",
    "fr-ca": "static-7.1019",
    "fr": "static-7.1019",
    "he-il": "static-7.1019",
    "hr": "static-7.1019",
    "hu": "static-7.1019",
    "id": "static-7.1019",
    "it": "static-7.1019",
    "ja": "static-7.1019",
    "ko": "static-7.1019",
    "lt": "static-7.1019",
    "ms": "static-7.1019",
    "nl": "static-7.1019",
    "no": "static-7.1019",
    "pl": "static-7.1019",
    "pt-br": "static-7.1019",
    "pt-pt": "static-7.1019",
    "ro": "static-7.1019",
    "ru": "static-7.1019",
    "sk": "static-7.1019",
    "sl": "static-7.1019",
    "sv": "static-7.1019",
    "th": "static-7.1019",
    "tl": "static-7.1019",
    "tr": "static-7.1019",
    "uk": "static-7.1019",
    "vi": "static-7.1019",
    "x-pseudo": "static-7.1019",
    "zh-cn": "static-7.1019",
    "zh-hk": "static-7.1019",
    "zh-tw": "static-7.1019"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fi', {version: 'static-7.1019'}); }
})();


